<app-main-layout-spacer>
  <app-sign-in-header></app-sign-in-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-bottom-toast-banner *ngIf="isBottomToastBannerVisible"></app-bottom-toast-banner>
</app-main-layout-spacer>
